<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Create team"
        :error="error"
        @close="$emit('close')"
    >
        <template #icon>
            <zen-icon-create />
        </template>
        <template #body>
            <div class="space-y-1 mb-6">
                <p class="text-sm text-taupe-600">
                    Create a team to organize users for easier permission
                    management.
                </p>
            </div>

            <div class="space-y-5">
                <div>
                    <label
                        for="team-name"
                        class="block text-sm font-medium leading-6 text-taupe-900"
                    >
                        Name
                        <span class="text-red-500">*</span>
                    </label>
                    <div class="mt-2">
                        <input
                            type="text"
                            name="team-name"
                            id="team-name"
                            :value="data.name"
                            @input="
                                $emit('update:data', {
                                    ...data,
                                    name: $event.target.value,
                                })
                            "
                            placeholder="e.g. Engineering"
                            class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 transition-shadow"
                        />
                    </div>
                </div>

                <div>
                    <label
                        for="team-description"
                        class="block text-sm font-medium leading-6 text-taupe-900"
                    >
                        Description
                    </label>
                    <div class="mt-2">
                        <textarea
                            name="team-description"
                            id="team-description"
                            :value="data.description"
                            @input="
                                $emit('update:data', {
                                    ...data,
                                    description: $event.target.value,
                                })
                            "
                            rows="3"
                            placeholder="Optional description of this team"
                            class="block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm sm:leading-6 transition-shadow"
                        />
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:buttons>
            <zen-button
                variant="secondary"
                size="medium"
                @click="$emit('close')"
            >
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                size="medium"
                :disabled="!canSubmit"
                :processing="processing"
                data-testid="create-team-submit-button"
                @click="$emit('confirm')"
            >
                Create Team
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'CreateTeamSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        data: {
            type: Object,
            required: true,
        },
        error: {
            type: [String, Object],
            default: null,
        },
        canSubmit: {
            type: Boolean,
            default: false,
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'confirm', 'update:data'],
}
</script>
